// extracted by mini-css-extract-plugin
export default {"dialog":"modal_dialog__1F-4+"};